/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SharedModule
 */

import { Component, Input } from '@angular/core';
import { IBreadcrumb } from '../full-modal.component';
import './full-modal-breadcrumbs.component.less';

/**
 * @description Component for displaying a list of breadcrumbs.
 * @author alextsg
 */
@Component({
    selector: 'full-modal-breadcrumbs',
    templateUrl: './full-modal-breadcrumbs.component.html',
})
export class FullModalBreadcrumbsComponent {
    /**
     * Stack of modals that the user is configuring.
     */
    @Input()
    public breadcrumbStack: IBreadcrumb[] = [];

    /**
     * TrackBy function for rendering the list of breadcrumbs.
     */
    public trackByIndex(index: number): number {
        return index;
    }
}
